import { decodeJwt } from 'jose';

/**
 * Determina si un token JWT ha expirado.
 * @param {string} token - Token JWT.
 * @returns {boolean} - true si el token expiró o es inválido; false si es válido y no ha expirado.
 */
export const isTokenExpired = (token) => {
    if (!token || typeof token !== 'string') {
        return true; // No hay token, se considera expirado
    }

    try {
        const decoded = decodeJwt(token);
        const exp = decoded.exp;

        if (!exp) {
            // El token no tiene fecha de expiración → por seguridad se trata como expirado
            console.warn('Token sin claim exp, se fuerza logout');
            return true;
        }

        const nowSeconds = Date.now() / 1000;
        return exp <= nowSeconds; // Comparación exacta
    } catch (error) {
        console.error('Error decodificando token:', error);
        return true; // Token inválido → expirado
    }
};